import { render, staticRenderFns } from "./SelectBlock.vue?vue&type=template&id=acb11e1c"
import script from "./SelectBlock.vue?vue&type=script&lang=js"
export * from "./SelectBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports